/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Downgrade_Addon_Price_WarningInputs */



/**
* | output |
* | --- |
* | "Add-on prices are higher on Starter" |
*
* @param {Sub_Downgrade_Addon_Price_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_addon_price_warning = /** @type {((inputs?: Sub_Downgrade_Addon_Price_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Addon_Price_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Add-on-Preise sind bei Starter höher")
	return /** @type {LocalizedString} */ ("Add-on prices are higher on Starter")
});